module.exports = __webpack_public_path__ + "img/GruposEnActivacion.510b7190.svg";